import { PHONE } from "@/mocks/updiag";
import { SHOW_REVIEWS } from "@/config/features";

export default function TopBar() {
  return (
    <div className="bg-[#0F3B5F] text-white text-xs hidden md:block">
      <div className="max-w-7xl mx-auto px-6 h-10 flex items-center justify-between">
        <div className="flex items-center gap-6">
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-fill text-[#16A34A]"></i>
            RDV sous 48h
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-award-fill text-[#F97316]"></i>
            Certifié COFRAC
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-map-pin-2-fill text-[#F97316]"></i>
            Paris &amp; Île-de-France
          </span>
          {SHOW_REVIEWS && (
            <span className="flex items-center gap-1.5">
              <i className="ri-star-fill text-[#F59E0B]"></i>
              4.9/5 — 127 avis Google
            </span>
          )}
        </div>
        <a
          href={`tel:${PHONE.replace(/\s/g, "")}`}
          className="flex items-center gap-2 font-semibold text-[#F97316] hover:text-white transition-colors duration-200"
        >
          <i className="ri-phone-fill"></i>
          {PHONE}
        </a>
      </div>
    </div>
  );
}
